import * as T from '../types';

const setPayError = () => (dispatch: any) => {
  dispatch({ type: T.PAY_REQUEST_FAIL });
  dispatch({ type: T.PAY_POLLING_FAIL });
};

export default setPayError;
